import { useContext, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import AppContext from "../../../context";
import Meta from "../../components/Meta";
import Loading from "../../components/Loading";

import Data from "../../../repository";
import { requestInductionSchema } from '../../../validation/schemas';

import styles from '../../../styles/Entry.module.scss';

function RequestInduction() {
	const context = useContext(AppContext);
	const navigate = useNavigate();

	const [loading, setLoading] = useState(false);
	const [serverError, setServerError] = useState(null);

	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm({
		resolver: yupResolver(requestInductionSchema),
		defaultValues: {
			phoneNumber: '',
			message: ''
		}
	});

	const onSubmit = async (data) => {
		setLoading(true);
		setServerError(null);

		try {
			await Data.requestInduction({
				firstName: context.user.firstName,
				lastName: context.user.lastName,
				email: context.user.email,
				phoneNumber: data.phoneNumber,
				message: data.message
			});

			navigate("/entry/terms");
		} catch (error) {
			setServerError(error.response?.data?.message || 'An error occurred. Please try again.');
			setLoading(false);
		}
	}

	return (
		<>
			<Meta title="Request Face-to-Face Induction" />

			<div className={styles.fullHeight}>
				<div>
					{serverError &&
						<div className={styles.error}>
							<p>{serverError}</p>
						</div>
					}

					<h1>Request Face-to-Face Induction</h1>
					<p>Please enter your contact details below, and give an indication of when you would like your induction to take place.</p>

					<form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
						<input type="text" value={context.user.email} disabled={true} />
						<div>
							<input
								type="text"
								placeholder="Phone Number"
								{...register('phoneNumber')}
								disabled={loading}
								className={errors.phoneNumber ? 'input-error' : ''}
							/>
							{errors.phoneNumber && <p className={styles.fieldError}>{errors.phoneNumber.message}</p>}
						</div>
						<div>
							<textarea
								placeholder="What time of the week would you prefer?"
								{...register('message')}
								rows={5}
								disabled={loading}
							/>
						</div>

						<div className={styles.actions}>
							<button type="submit" className="btn btnPrimary" disabled={loading}>
								{loading ?
									<Loading button={true} />
									:
									`Request Induction`
								}
							</button>
						</div>
					</form>
				</div>
			</div>
		</>
	);
}

export default RequestInduction;
